
import { defineComponent } from "vue";

interface Shape {
    img: string;
    label: string;
}

export default defineComponent({
    name: "DiamondShapeButton",
    props: {
        shape: {
            type: Object,
            required: true
        }
    }
});
